// extracted by mini-css-extract-plugin
module.exports = {"GalleryList":"GalleryList_GalleryList__C9Hao","noData":"GalleryList_noData__1y5Xz","btn_back":"GalleryList_btn_back__2v8ao"};